import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
  baseUrl: '/api',
});

const baseQueryWithRetry = retry(baseQuery, {
  // prevent return on 401
  maxRetries: 0,
});

export const api = createApi({
  reducerPath: 'splitApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: ['Reminders', 'ApiKeys', 'Vendors'],
  // tagTypes: ['Orders', 'ProductDetail', 'Products'],
  endpoints: () => ({}),
});

export const enhancedApi = api.enhanceEndpoints({
  endpoints: {},
});
